import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const ReportQueryStatus = iotsUtils.fromList(constants.report.reportQueryStatuses);
